module.exports = __webpack_public_path__ + "static/media/draw-social-networking.1d84ebc6.svg";